import { WorkerAvailabilityRequest } from 'api/worker'
import { QueryKeys } from 'queries/types'

const ROOT = 'worker'

export const workerKeys = {
  profile: (workerId: number) => [ROOT, workerId?.toString(), 'profile'],

  rosterDetail: (rosterId: number) => [ROOT, 'roster', rosterId.toString()],

  pendingInvites: [ROOT, 'pendingInvites'],

  shifts: (workerId: number) => [ROOT, workerId?.toString(), 'shifts'],

  compliments: (workerId: number) => [ROOT, workerId.toString(), 'compliments'],

  tipHistory: (filters: { workerId?: number; shiftId?: number }) => [
    ROOT,
    'tipHistory',
    filters,
  ],

  logs: (query: { startDate: Date; endDate: Date; workerId: number }) => [
    ROOT,
    query.workerId.toString(),
    'logs',
    'startDate',
    query.startDate.toISOString(),
    'endDate',
    query.endDate.toISOString(),
  ],

  availability: ({
    workerIds,
    hypotheticalShifts,
    shiftIds,
  }: WorkerAvailabilityRequest) => [
    ROOT,
    'availabilities',
    workerIds?.join('|'),
    hypotheticalShifts
      ?.map(
        (shift) =>
          `${shift?.positionId}-${shift?.locationId}-${shift?.start}-${shift?.end}`
      )
      .join('|'),
    shiftIds?.join('|'),
  ],
} satisfies QueryKeys
